import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from './auth';
import { Snackbar } from './components/snackbar';
import { HistoryProvider } from './routes/context/HistoryContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
    },
  },
});

function App({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Snackbar />
        <HistoryProvider>{children}</HistoryProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
